import { useState, useEffect, useCallback } from 'react';
import supabase from '../../supabase-client';

export const useThingDetail = (thingId) => {
  const [thing, setThing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchThing = useCallback(async () => {
    if (!thingId) return;

    try {
      setLoading(true);
      setError(null);

      const { data, error: fetchError } = await supabase
        .from('thingproduct')
        .select('*')
        .eq('id_thing', thingId)
        .single();

      if (fetchError) {
        throw new Error(fetchError.message);
      }

      if (!data) {
        throw new Error('Accesorio no encontrado');
      }

      // Map the data to a more user-friendly format
      const mappedThing = {
        id: data.id_thing,
        title: data.title_thing,
        description: data.description_thing,
        price: data.price_thing,
        originalPrice: data.price_thing,
        available: data.available_thing,
        stock: data.stock_thing || 0,
        rating: data.rating_thing || 0,
        images: data.image_urls || [],
        brand: data.brand_thing || '',
        material: data.material_thing || '',
        dimensions: data.dimensions_thing || '',
        weight: data.weight_thing || '',
        color: data.color_thing || '',
        features: [],
        specifications: {},
        careInstructions: [],
        isNew: data.is_new_thing || false,
        favoriteCount: data.favorite_count_product || 0,
        favorite_product: data.favorite_product,
        category: data.category_thing || ''
      };

      setThing(mappedThing);
    } catch (err) {
      console.error('Error fetching thing:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [thingId]);

  const refreshThing = useCallback(() => {
    fetchThing();
  }, [fetchThing]);

  const toggleFavorite = useCallback(async (isFavorite) => {
    if (!thing?.id) return false;

    try {
      // This would integrate with your favorites system
      // For now, just simulate the API call
      console.log(`Toggle favorite for thing ${thing.id}: ${isFavorite}`);
      return true;
    } catch (error) {
      console.error('Error toggling favorite:', error);
      return false;
    }
  }, [thing?.id]);

  const fetchRelatedThings = useCallback(async () => {
    if (!thing) return [];

    try {
      const { data, error: fetchError } = await supabase
        .from('thingproduct')
        .select(`
          id_thing,
          title_thing,
          description_thing,
          price_thing,
          available_thing,
          image_urls
        `)
        .neq('id_thing', thing.id)
        .limit(8);

      if (fetchError) {
        console.error('Error fetching related things:', fetchError);
        return [];
      }

      return (data || []).map(item => ({
        id: item.id_thing,
        title: item.title_thing,
        description: item.description_thing,
        price: item.price_thing,
        available: item.available_thing,
        image: item.image_urls?.[0]
      }));
    } catch (error) {
      console.error('Error fetching related things:', error);
      return [];
    }
  }, [thing]);

  useEffect(() => {
    fetchThing();
  }, [fetchThing]);

  return {
    thing,
    loading,
    error,
    refreshThing,
    toggleFavorite,
    fetchRelatedThings
  };
};

